import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Grid, Box} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import TableChartIcon from "@material-ui/icons/TableChart";
import FunctionsIcon from "@material-ui/icons/Functions";
import ArbCalculator from "./LayCalculator";
import ArbTable from "./LayTable";
import headerStyle from "../../../jss/Header";
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({ ...headerStyle(theme) }));

const Lay = () => {
	const classes = useStyles();
	const [mode, setMode] = useState("calculator");

	const toggleMode = () => {
		if (mode === "calculator") setMode("table");
		else if (mode === "table") setMode("calculator");
	};

	return (
		<div className={clsx (classes.root,"lay" )}>
			<Box mt={5}/>
			<Grid container spacing={3}>
				<Grid item xs={12} className={classes.title}>
					<Box fontSize="30px" fontWeight="bold">
						Lay
						<IconButton color="inherit" aria-label="Toggle" edge="start" onClick={toggleMode}>
							{mode === "calculator" ? <TableChartIcon /> : <FunctionsIcon />}
						</IconButton>
					</Box>
				</Grid>
				{mode === "calculator" ? <ArbCalculator /> : <ArbTable />}
			</Grid>
		</div>
	);
};

export default Lay;
